module.exports = __webpack_public_path__ + "img/img17.4944498c.svg";